<template>
  <div class="body">
       <Tables ref="tableGridsTemplateAprFerramenta"
                :columns= columTemplate
                :showSearch="false"
                :showPrint="false"
                :newHeaderStatus="true"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad">
                <tr v-for="obj in dataFerramentasTemplateAPR" :key="obj.id">
                <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)"  :status="1" :value="obj.descricao != null ? obj.descricao: 'N/D'" />
                <TableColumn :IsTextGreen="obj.statusAprovacao === null" :IsTextDanger="obj.statusAprovacao === 2" :IsTextGreeen="obj.statusAprovacao === 1" :IsTextYellow="obj.statusAprovacao === 0"   v-on:Edit="onSelect(obj)" :status="1" :value="obj.statusAprovacaoDescricao != null ? obj.statusAprovacaoDescricao: 'N/D'" />
                <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.tipoMudanca != null ? obj.tipoMudanca: 'N/D'" />
                <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.dateCricaoFormatada != null ? obj.dateCricaoFormatada: 'N/D'" />
                <TableColumn
                :deletePopup="obj.ferramentasId != null || obj.ferramentaId != null"
                :IsActiveButton=" aprTemplateReprovado === true ? false : obj.statusAprovacao != 2 ? true : false"
                :HasDelete="false"
                 v-on:Edit="DetailsExpense(obj)"
                 v-on:DeletePopup="DeletePopup(obj)"
                />
                </tr>
    </Tables>

    <b-modal ref="add-ferramentas"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
    <template #modal-title>
      <div class="header-title">ADICIONAR FERRAMENTAS</div>
    </template>
     <addFerramentasApr @AdicionarTableFerramentas="AdicionarTableFerramentas" @cancelarFerramentas="cancelarferramentas" @salvarFerramentas="salvarFerramentas" :revisao="revisao" :aprId="aprId"></addFerramentasApr>
    </b-modal>
  </div>

</template>

<script>
import tableEpi from './toolsTable'
export default tableEpi
</script>

<style scoped>
.body {
    margin-top: 1rem;
}
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/toolsTable/toolsTable.vue